export const SideBaseModule = {
    "LEFT": "Слева",
    "RIGHT": "Справа",
    "CORNER_LEFT": "Угловое левое",
    "CORNER_RIGHT": "Угловое правое",
    "ALL": "Любая сторона",
}